import {
  type CommissionFieldOptions,
  commissionFields,
  commissionLayoutRow,
} from '../../../shared/cards/commissionFields';
import { personalDealField } from '../../../shared/cards/complianceUpstreamFields';
import type { CoverSheetConfigCard } from '../../../types';

/**
 * Landlord and tenant leases capture one commission each, differing only in
 * whose agent is being paid.
 */
export const buildCommissionDetailsCard = (
  labels: CommissionFieldOptions,
): CoverSheetConfigCard => ({
  id: 'propertyInfo.commissionDetails',
  innerTitle: 'Commission Details',
  legend: '',
  layout: [
    commissionLayoutRow('commission'),
    [{ name: 'isPersonalDeal', size: 25, mobileSize: 50 }],
  ],
  fields: {
    ...commissionFields('commission', labels),
    isPersonalDeal: personalDealField,
  },
});
